export interface BoardMaster {
  id: number;
  code: string;
  name: string;
  description?: string;
  isActive: boolean;
  displayOrder: number;
}

export const boardService = {
  // Fetch active boards for student/parent onboarding and dropdowns
  async getActiveBoards(): Promise<BoardMaster[]> {
    try {
      const response = await fetch('/api/boards');
      if (!response.ok) {
        throw new Error('Failed to fetch active boards');
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching active boards:', error);
      return [];
    }
  }
};

export default boardService;
